import React from "react";
import { mongoDBDateParserToUSAFormat } from "../../../../../../utils/commonFunctions/date";
import { EOBEligibleMembers } from "../../../../../../types/EOBDetails.types";
import { ITotalData } from "../../../../../../types/totalData.types";
const ExplanationOfBenefitsGridPrint: React.FC<any> = ({ eligibleMembers, claimTotal }): JSX.Element => {
	const headers = [
		"Service Type",
		"Service From",
		"Service Thru",
		"Total Charges",
		"Not Covered or Penalty",
		"Discount",
		"Eligible Expense",
		"Remark Code",
		"Co-pay",
		"Deductible Amount",
		"Paid at Percentage",
		"Benefit Paid"
	];

	const totalData: ITotalData[] =
		claimTotal && claimTotal.length > 0
			? [
					{
						DESCR: "Total",
						INCFRMDT: claimTotal[0]["INCFRMDT"],
						INCTODT: "",
						CHGAMT: claimTotal[0]["SUM(D.CHGAMT)"],
						"(D.EERESP-(D.DEDAMT+D.COPAMT+D.COINAMT))": 0,
						PRVRESP: claimTotal[0]["SUM(D.PRVRESP)"],
						ADJCVRD: claimTotal[0]["SUM(D.ADJCVRD)"],
						EXPLCD01: 13,
						COPAMT: claimTotal[0]["SUM(D.COPAMT)"],
						DEDAMT: claimTotal[0]["SUM(D.DEDAMT)"],
						PERC: claimTotal[0]["TOTAL_NOT_COVERED"],
						PLNRESP: claimTotal[0]["SUM(D.PLNRESP)"],
						total_charges: ""
					}
			  ]
			: [];

	const headersWithValue = Object.keys(eligibleMembers[0]);

	const numericColumns = ["total_charges", "discount", "deductable_amount", "paid_at_percentage", "benefit_paid"];

	const calculateTotal = (column: keyof EOBEligibleMembers) => {
		return eligibleMembers.reduce((total: any, member: any) => {
			const columnValue = member[column];
			return typeof columnValue === "number" ? total + columnValue : total;
		}, 0);
	};

	// console.log("=====>headers with value", headersWithValue);

	const totalRow = (
		<tr>
			{headers.map((header, index) => (
				<td key={index} style={{ border: "1px solid black", padding: "8px" }}>
					{numericColumns.includes(header) ? calculateTotal(header as keyof EOBEligibleMembers) : ""}
				</td>
			))}
		</tr>
	);

	return (
		<table style={{ borderCollapse: "collapse", width: "100%", marginTop: "16px" }}>
			<thead style={{ backgroundColor: "#f1e6ff", fontSize: "14px" }}>
				<tr>
					{headers.map((header, index) => (
						<th key={index} style={{ border: "1px solid black", padding: "4px 2px" }}>
							{header}
						</th>
					))}
				</tr>
			</thead>
			<tbody>
				{eligibleMembers.map((member: any, rowIndex: number) => (
					<tr key={rowIndex} style={{ backgroundColor: rowIndex % 2 === 0 ? "#e6e6e6" : "white" }}>
						{headersWithValue.map((header, colIndex) => (
							<td
								key={colIndex}
								style={{
									border: "1px solid black",
									fontSize: "12px",
									textAlign: "center"
								}}
							>
								{header === "INCFRMDT" || header === "INCTODT"
									? mongoDBDateParserToUSAFormat(member[header as keyof EOBEligibleMembers])
									: member[header as keyof EOBEligibleMembers]}
							</td>
						))}
					</tr>
				))}
				<tr style={{ backgroundColor: eligibleMembers.length % 2 === 0 ? "#e6e6e6" : "white" }}>
					{headersWithValue.map((header, index) => (
						<td
							style={{
								border: "1px solid black",
								fontSize: "12px",
								textAlign: "center"
							}}
							key={index}
						>
							{totalData[0][header as keyof ITotalData]}
						</td>
					))}
				</tr>
				{/* interface EOBEligibleMembers {
					// existing properties...
					discount: number;
				} */}

				{/* <tr>
					{totalData.map((data, index) => (
						<td key={index} style={{ border: "1px solid black", padding: "8px" }}>
							{numericColumns.includes(headers[index] as keyof EOBEligibleMembers)
								? data[headers[index] as keyof EOBEligibleMembers]
								: ""}
						</td>
					))}
				</tr> */}
			</tbody>
		</table>
	);
};

export default ExplanationOfBenefitsGridPrint;
